// Consent-aware analytics initialisation.
// PostHog will ONLY be initialised after the user grants consent for analytics cookies.

const CONSENT_KEY = "ss-cookie-consent-v2";

/**
 * Consent shape:
 * {
 *   necessary: true (always),
 *   analytics: boolean,
 *   timestamp: ISO string,
 *   version: number,
 * }
 */

export const getConsent = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const saveConsent = (partial) => {
  const consent = {
    necessary: true,
    analytics: false,
    ...partial,
    timestamp: new Date().toISOString(),
    version: 2,
  };
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch {
    /* ignore quota/security errors */
  }
  return consent;
};

export const clearConsent = () => {
  try {
    window.localStorage.removeItem(CONSENT_KEY);
  } catch {
    /* ignore */
  }
};

let posthogInitialized = false;

export const initAnalytics = () => {
  if (typeof window === "undefined") return;
  if (posthogInitialized) return;
  if (!window.posthog || typeof window.posthog.init !== "function") return;

  try {
    window.posthog.init("phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs", {
      api_host: "https://us.i.posthog.com",
      person_profiles: "identified_only",
      session_recording: {
        recordCrossOriginIframes: true,
        capturePerformance: false,
      },
    });
    posthogInitialized = true;
  } catch {
    /* silently ignore init errors */
  }
};

export const disableAnalytics = () => {
  if (typeof window === "undefined") return;
  if (window.posthog && typeof window.posthog.opt_out_capturing === "function") {
    try {
      window.posthog.opt_out_capturing();
    } catch {
      /* ignore */
    }
  }
};

/**
 * Applies stored consent on app boot. Call once in App.js.
 */
export const applyStoredConsent = () => {
  const c = getConsent();
  if (c && c.analytics) initAnalytics();
};
